import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  Input,
  Output,
  Component,
  OnDestroy,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnListItem } from '../../models';
import { SnListItemConfig } from '../../types';

@Component({
  selector: 'sn-list',
  templateUrl: './list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-list',
  },
})
export class SnListComponent implements OnDestroy {
  @Input()
  public title: string;

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('items')
  set itemConfigs(value: SnListItemConfig[]) {
    this._items = value.map(SnListItem.fromConfig);
  }

  @Input()
  set avatar(value: boolean) {
    this._avatar = coerceBooleanProperty(value);
  }
  get avatar(): boolean {
    return this._avatar;
  }

  @Input()
  set twoLine(value: boolean) {
    this._twoLine = coerceBooleanProperty(value);
  }
  get twoLine(): boolean {
    return this._twoLine;
  }

  @Input()
  set interactive(value: boolean) {
    this._interactive = coerceBooleanProperty(value);
  }
  get interactive(): boolean {
    return this._interactive;
  }

  @Output()
  public readonly itemClick: EventEmitter<SnListItem> = new EventEmitter();

  private _items: SnListItem[] = [];
  private _avatar: boolean;
  private _twoLine: boolean;
  private _interactive: boolean = true;

  constructor() {}

  get items(): SnListItem[] {
    return this._items;
  }

  get dense(): boolean {
    return this._avatar || this._twoLine;
  }

  public ngOnDestroy(): void {
    this.itemClick.complete();
  }

  public trackItem(index: number): any {
    return index;
  }

  public onItemClick(item: SnListItem): void {
    this.itemClick.emit(item);
  }
}
